/*
 * Cadwork webgl Engine
 * http://www.lexoview.com
 *
 * Copyright (C) 2015 Cadwork Informatik AG, Basel, Switzerland
 * Dual licensed under the MIT and GPL
 *
 * @author Jaroslav Přibyl (pribyl@cadwork.cz)
 *
 */

import BufferHandler from "App/render/webgl/utils/buffer_handler";
import Batch from "App/render/webgl/renderables/batches/batch";
import MemoryManagement from "App/memory_management";

export default
class ArrayBufferHandler extends BufferHandler {

    public static TypeName: string = "ArrayBufferHandler";
    public static maxVerticesCount: number = 65535;

    constructor(aBatch: Batch) {
        super(aBatch);
    }

    public release() {
        super.release();
    }

    public reCreateBuffer(aVerticesCount: number, aAtributeSize: number) {
        this.release();
        this.createBuffer(aVerticesCount, aAtributeSize);
    }

    public createBuffer(aVerticesCount: number, aAttributeSize: number) {
        let gl = this._context.getWebGLRenderingContext();

        this.size = aVerticesCount;
        this.bytesSize = this.size * aAttributeSize * 4;
        this.filledSize = 0;
        this.id = gl.createBuffer();

        gl.bindBuffer(gl.ARRAY_BUFFER, this.id);
        let bufferData = new Float32Array(aVerticesCount * aAttributeSize);
        gl.bufferData(gl.ARRAY_BUFFER, bufferData, gl.STATIC_DRAW);

        MemoryManagement.addBufferObject(this.bytesSize);
    }

    public canHandleVertices(aVerticesToHandle: number) {
        return aVerticesToHandle <= this.size;
    }

    public add(aData: Float32Array, aAttributeSize: number) {
        let gl = this._context.getWebGLRenderingContext();

        let addedVerticesCount = aData.length / aAttributeSize;
        gl.bufferSubData(gl.ARRAY_BUFFER, this.filledSize * aAttributeSize * 4, aData); // * 4 because of the Float32Array used in createBuffer
        this.filledSize += addedVerticesCount;

        return this.filledSize - addedVerticesCount;
    }

    public update(aData: BufferSource, aPosition: number, aAtributeSize: number) {
        let gl = this._context.getWebGLRenderingContext();
        gl.bufferSubData(gl.ARRAY_BUFFER, aPosition * aAtributeSize * 4, aData); // * 4 because of the Float32Array used int _createBuffer
    }

    public bindBuffer() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindBuffer(gl.ARRAY_BUFFER, this.id);
    }

    public unbindBuffer() {
        let gl = this._context.getWebGLRenderingContext();
        gl.bindBuffer(gl.ARRAY_BUFFER, null);
    }
}
